import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

const PENDING_CUSTOM_DOMAIN_PURCHASE_KEY = 'pendingCustomDomainPurchase'

const initialState = {
  dnsAddress: {
    domain: '',
    selected: null,
    checked: false,
    subdomain: ''
  },
  path: {
    selected: null,
    domain_search: [],
    selected_domain: {
      name: '',
      price: '',
      available: false,
      status: '',
      payment_success: false,
      isPremium: false
    },
    confirmNoRefund: false
  },
  wizard: {
    selected: null
  },
  dnsRecords: {
    checked: false,
    data: null
  },
  registrantContact: {
    RegistrantFirstName: '',
    RegistrantLastName: '',
    RegistrantEmailAddress: '',
    RegistrantPhone: '',
    RegistrantAddress1: '',
    RegistrantCity: '',
    RegistrantStateProvince: '',
    RegistrantPostalCode: '',
    RegistrantCountry: ''
  },
  expired: false,
  validationFailed: false,
  isSetUpComplete: false
}

export const useCustomDomainModal = ({ show, onClose, modalData }) => {
  const [activeStep, setActiveStep] = useState(0)
  const [initialValues, setInitialValues] = useState(initialState)
  const history = useHistory()

  const createdTime = localStorage.getItem('start_time')
  const formValues = localStorage.getItem('form_values')
  const retry = localStorage.getItem('retry')
  const validate = localStorage.getItem('validate')

  useEffect(() => {
    if (show) {
      history.push({ pathname: '/manage/custom-domain/add' })
    }
  }, [show, history])

  useEffect(() => {
    if (show) {
      const createdTime = localStorage.getItem('start_time')
      const retry = localStorage.getItem('retry')
      const validate = localStorage.getItem('validate')
      const pendingCustomDomainPurchase = localStorage.getItem(PENDING_CUSTOM_DOMAIN_PURCHASE_KEY)

      if (modalData) {
        setInitialValues({
          ...initialState,
          dnsAddress: {
            ...initialState.dnsAddress,
            domain: modalData.domain,
            subdomain: modalData.subdomain || ''
          },
          wizard: {
            selected: modalData.cancelled ? 'no' : null
          },
          dnsRecords: {
            ...initialState.dnsRecords,
            data: modalData
          }
        })
        if (modalData.cancelled) {
          setActiveStep(3)
        } else {
          setActiveStep(3)
        }
      } else if (pendingCustomDomainPurchase) {
        setInitialValues({
          ...initialState,
          dnsAddress: {
            ...initialState.dnsAddress,
            domain: pendingCustomDomainPurchase,
            selected: 'no'
          }
        })
        setActiveStep(2)
        localStorage.removeItem(PENDING_CUSTOM_DOMAIN_PURCHASE_KEY)
        history.replace({ pathname: '/manage/custom-domain/buy' })
      } else if (validate) {
        setActiveStep(3)
      } else if (retry) {
        setActiveStep(4) // Retry logic usually goes to step 4
      } else if (createdTime) {
        setActiveStep(4)
      } else {
        setActiveStep(0)
      }
    }
  }, [show, modalData])

  useEffect(() => {
    if (formValues) {
      setInitialValues((prev) => ({ ...prev, ...JSON.parse(formValues) }))
    }
  }, [formValues])

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1)
  }

  const handleClose = () => {
    localStorage.removeItem('retry')
    localStorage.removeItem('form_values')
    localStorage.removeItem('start_time')
    localStorage.removeItem('validate')
    localStorage.removeItem('view_records')
    localStorage.removeItem('publishToCustomDomain')
    localStorage.removeItem('isServerFileForCustomDomain')

    onClose()
    setActiveStep(0)
    setInitialValues(initialState)
    history.push('/manage')
  }

  const handleFinish = () => {
    handleClose()
  }

  return {
    activeStep,
    initialValues,
    setActiveStep,
    handleNext,
    handleBack,
    handleClose,
    handleFinish
  }
}
